import { GroupType } from '../typings/domain';
import { GroupId } from '../typings/groups';

export const OPEN_PLATFORM_PREVIEW_HEADER = 'OPEN_PLATFORM_PREVIEW_HEADER';
export type OPEN_PLATFORM_PREVIEW_HEADER = typeof OPEN_PLATFORM_PREVIEW_HEADER;

export interface OpenPlatformPreviewHeader {
    type: OPEN_PLATFORM_PREVIEW_HEADER;
    groupId: GroupId;
    regionId: string;
    previewType: GroupType;
}

export function openPlatformPreviewHeader(
    groupId: GroupId,
    regionId: string,
    previewType: GroupType
): OpenPlatformPreviewHeader {
    return {
        type: OPEN_PLATFORM_PREVIEW_HEADER,
        groupId,
        regionId,
        previewType
    };
}

export const CLOSE_PLATFORM_PREVIEW_HEADER = 'CLOSE_PLATFORM_PREVIEW_HEADER';
export type CLOSE_PLATFORM_PREVIEW_HEADER = typeof CLOSE_PLATFORM_PREVIEW_HEADER;

export interface ClosePlatformPreviewHeader {
    type: CLOSE_PLATFORM_PREVIEW_HEADER;
    groupId: GroupId;
    regionId: string;
}

export function closePlatformPreviewHeader(
    groupId: GroupId,
    regionId: string
): ClosePlatformPreviewHeader {
    return {
        type: CLOSE_PLATFORM_PREVIEW_HEADER,
        groupId,
        regionId
    };
}

export type OpenPlatformPreviewHeaderAction =
    | OpenPlatformPreviewHeader
    | ClosePlatformPreviewHeader;
